<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label style=" font-size: var(--font-medium);" for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select @change="searchTypeChanged" style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('çraçı')" :value="4"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0"
              @keyup.enter.native="clickSearch" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            <div style="position: absolute; right: 0;">
              <el-button size="small" type="primary" icon="fa-solid fa-user-group" @click="showDialog = true">&nbsp;İş
                sayları</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">
        <el-checkbox @change="getData" v-model="item.noResponsible">{{$t('Bütün_işlər')}}</el-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <el-table @selection-change="handleSelectionChange" :default-expand-all="true" v-loading="loading" :data="displayData
          " style="width: 100%">
          <el-table-column type="selection" width="55" />
          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Tarix')" sortable prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı')" sortable prop="insuredName" width="260">
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" sortable prop="insuranceTypeName" width="150">
          </el-table-column>
          <el-table-column :label="$t('Şəxs_növü')" sortable prop="personTypeName" width="150">
          </el-table-column>
          <el-table-column :label="$t('Zəncirvari')" prop="commChainAccidentName" width="200">
          </el-table-column>
          <el-table-column :label="$t('N\V_sayı')" prop="vehicleCount" width="120">
          </el-table-column>
          <el-table-column :label="$t('Rayon')" prop="regionName" width="150">
          </el-table-column>
          <el-table-column :label="$t('İcraçı')" prop="clientServiceUserName">
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button  @click="handleUser(scope.row)" :title="$t('Məsul_şəxs')" style="padding: 0 !important" size="large">
                <div class="square-icon">
                  <i class="fa-solid fa-person-circle-check"></i>
                </div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button :title="$t('Hadisəyə_keçid')" @click="handleEdit(scope.row.id)" style="padding: 0 !important"
                size="large">
                <div class="square-icon">
                  <i class="fa-solid fa-up-right-from-square "></i>
                </div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.id,'accident')" style="padding: 0 !important">
                <div class="square-icon"> <i :title="$t('Ümumi_Statuslar')" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
    <client-service-user @refresh-table="getData" ref="user" />
    <el-dialog :title="$t('Hadisə_və_iş_sayları')" :visible.sync="showDialog" width="55%">
      <div>
        <div>
          <el-table v-loading="loading" :data="clientUserCount" style="width: 100%">

            <el-table-column :label="$t('Icraçı')" sortable prop="fullName" width="200">
            </el-table-column>
            <el-table-column :label="$t('Bügun_təyin_olunan_hadisə')" sortable prop="totalAccidentsToday" width="230">
            </el-table-column>
            <el-table-column :label="$t('Toplam_cari_hadisələr')" sortable prop="totalAccidents" width="200">
            </el-table-column>
            <el-table-column :label="$t('Toplam_cari_işlər')" sortable prop="totalClaims" width="200">
            </el-table-column>
          </el-table>
        </div>
      </div>

    </el-dialog>
    <accident-status-view ref="status" />
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";

// import StatusLabel from "../components/StatusLabel.vue";
import {
  GetRespUserAccidents,
  GetClientUserAccidentCount,
} from "src/services/common";
import AccidentStatusView from "../components/AccidentStatusView.vue";
import ClientServiceUser from "../servicecenter/ClientServiceUser.vue";
export default {
  components: {
    ClientServiceUser,
    AccidentStatusView
    // StatusLabel
  },
  data() {
    return {
      loading: false,
      data: [],
      filteredData: [],
      search: "",
      showDialog: false,

      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        newClaim: false,
        noResponsible: false,
        pageNumber: 1,
        pageSize: 50
      },
      clientUserCount: [],

      displayData: [],
      totalRecords: 0,
      filter: {
        page: 1,
        pagesize: 50,
      },
      selectedAccident: [],
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedAccident = val;
    },
    searchTypeChanged() {
      this.item.searchText = null;
      if (this.item.searchType === 0) {
        this.getData();
      }
    },
    handleStatusView(id, type) {
      this.$refs["status"].view(id, type);
    },
    handleCommand(command) {
      if (command.action === "user") this.handleUser(this.selectedAccident);
    },
    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "../servicecenter/accident/" + id });
      window.open(routeData.href, "_blank");
    },
    handleUser(item) {
      if (!this.selectedAccident || this.selectedAccident.length === 0) {
        this.selectedAccident = [item];
      }
      this.$refs["user"].edit(this.selectedAccident);
    },

    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    getData() {
      this.loading = true;

      if (this.item.searchText == "") {
        this.item.searchText = null;
      }

      
       this.item.startDate = DateToString(this.item.startDate);
        this.item.endDate = DateToString(this.item.endDate);
      this.item.pageNumber = this.filter.page;
      this.item.pageSize = this.filter.pagesize;

      GetRespUserAccidents(this.item).then((response) => {
        this.loading = false;

        if (response && response.data.data && response.data.data.length > 0) {
          this.data = response.data.data;
          this.totalRecords = response.data.data?.[0].totalRecords || 0; 
          this.displayData = this.data;
        } 
        else {
          this.displayData = [];
          this.totalRecords = 0;
        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -7);
      this.item.endDate = AddDays(new Date(), +1);
    },
    getClientUserAccidentCount() {
      GetClientUserAccidentCount().then((response) => {
        if (response.data.data) {
          this.clientUserCount = response.data.data;
        } else {
        }
      });
    },
    filterData() {
      this.displayData = this.data.filter((data) => {
        if (!this.search) {
          return true;
        }

        const normalizedSearch = this.search.normalize("NFC").toLocaleLowerCase('az');

        return (
          data.participants
            .toString()
            .normalize("NFC")
            .toLocaleLowerCase('az')
            .includes(normalizedSearch) ||
          data.regionName
            .normalize("NFC")
            .toLocaleLowerCase('az')
            .includes(normalizedSearch) ||
          data.clientServiceUserName
            .normalize("NFC")
            .toLocaleLowerCase('az')
            .includes(normalizedSearch) ||
          data.participants
            .includes(normalizedSearch) ||
          data.dispAccidentNumber
            .toString()
            .toLocaleLowerCase('az')
            .includes(normalizedSearch)

        );
      });
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val;
      this.getData();
    },
  },
  watch: {
    search: {
      handler() {
        this.filter.page = 1;
        this.filterData();
      },
      immediate: false,
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
    this.getClientUserAccidentCount();
  },

};
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
